export const LOCAL_STORAGE_KEY_GARAGE_VEHICLES = 'garage_vehicles';
export const LOCAL_STORAGE_KEY_AUTH_TOKEN = 'authToken';
export const LOCAL_STORAGE_KEY_USER_DATA = 'userData';
export const LOCAL_STORAGE_KEY_SELECTED_STORE = 'selected_store';
export const LOCAL_STORAGE_SAVED_FOR_LATER = 'allas_saved_for_later';
